import React, {useState, useEffect} from 'react';
import {Link as RouterLink, useHistory} from 'react-router-dom';
import Link from '@mui/material/Link';
import {Container, Button, Grid} from '@mui/material'
import {CommodityTypeService} from '../../../services';
import CustomDataGrid from '../../../customUtil/DataGrid';

const columns = [
    {
        field: 'typeCode', headerName: 'Type', width: 230,
        renderCell: (params) => (
            <Link style={{textDecoration: 'none'}} component={RouterLink} to={'/references/commodity-type/' + params.row.id}>
                {params.value}
            </Link>
        )
    },
    {field: 'name', headerName: 'Name', width: 430},
    {field: 'registrationRequiredByDefault', headerName: 'Registration Required', width: 230}
]

const CommodityType = () => {
        const [list, setList] = useState([]);
        const history = useHistory();

        useEffect(() => {
            CommodityTypeService.getAll()
                .then((response) => {
                    setList(response.data);
                });
        }, []);

        return (
            <Container>
                <header>
                    <h1>Commodity Types</h1>
                </header>
         
                    <Grid container spacing={5}>
                    <Grid item xs={12}>
                        <Button variant='contained' color='primary' onClick={() => {history.push('/references/commodity-type/new')}}>Create New</Button>
                        </Grid>                        
                        <Grid item xs={12}>
                        <CustomDataGrid 
                                rows={list}
                                columns={columns}
                                rowHeight={35}
                                />
                        
                        </Grid>
                    </Grid>
                   
            </Container>
        );
    }
;

export default CommodityType;
